import { render, staticRenderFns } from "./CourseCompare.vue?vue&type=template&id=a4f36932&scoped=true&"
import script from "./CourseCompare.vue?vue&type=script&lang=js&"
export * from "./CourseCompare.vue?vue&type=script&lang=js&"
import style0 from "./CourseCompare.vue?vue&type=style&index=0&id=a4f36932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f36932",
  null
  
)

export default component.exports